import { useState } from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Users, BarChart3 } from "lucide-react";
import { motion } from "framer-motion";

export default function Sidebar() {
    const [open, setOpen] = useState(true);

    const menu = [
        { name: "Dashboard", path: "/dashboard", icon: <LayoutDashboard size={20} /> },
        { name: "Leads", path: "/leads", icon: <Users size={20} /> },
        { name: "Analytics", path: "/analytics", icon: <BarChart3 size={20} /> },
    ];

    return (
        <motion.div
            animate={{ width: open ? 240 : 80 }}
            className="h-screen bg-white/5 backdrop-blur-xl border-r border-white/10 p-4 flex flex-col"
        >
            {/* Toggle */}
            <button
                onClick={() => setOpen(!open)}
                className="mb-8 text-xl hover:scale-110 transition"
            >
                ☰
            </button>

            {/* Logo */}
            <div className="mb-10 text-xl font-bold tracking-wide">
                ⚡ {open && "Shriansh"}
            </div>

            {/* Menu */}
            <nav className="space-y-3">
                {menu.map((item, i) => (
                    <NavLink
                        key={i}
                        to={item.path}
                        className={({ isActive }) =>
                            `flex items-center gap-3 p-3 rounded-xl transition-all 
                            ${isActive
                                ? "bg-gradient-to-r from-purple-600 to-indigo-600 shadow-lg"
                                : "hover:bg-white/10"}`
                        }
                    >
                        {item.icon}
                        {open && <span>{item.name}</span>}
                    </NavLink>
                ))}
            </nav>
        </motion.div>
    );
}